import React from "react"
import * as paths from "constants/paths"
import SubHeader from "components/Shared/SubHeader"
import CrossSellingGlobalFilters from "../CrossSellingGlobalFilters/CrossSellingGlobalFilters"
import CrossSellingCalendar from "components/Labs/CrossSellingCalendar/CrossSellingCalendar"
import { SinglePeriod } from "components/Labs/CrossSelling/interfaces"
import NewModuleTag from "components/Shared/NewModuleTag/NewModuleTag"

type CrossSellingProps = {
	onChangeCalendar: (interval: SinglePeriod) => void
	newModuleConfig: {
		isNewModule?: boolean
		startDate?: Date
		endDate?: Date
	}
}

const CrossSellingSubHeader: React.FC<CrossSellingProps> = (props) => {
	const { onChangeCalendar, newModuleConfig } = props
	return (
		<SubHeader
			title={"phronesis.transactional"}
			newModuleContent={
				newModuleConfig.isNewModule && (
					<NewModuleTag
						from={newModuleConfig.startDate as Date}
						to={newModuleConfig.endDate as Date}
					/>
				)
			}
			subTitle={"phronesis.transactional.application.cross-selling.title"}
			titleContent={
				<div className="phronesis-calendar">
					<CrossSellingCalendar setPeriod={onChangeCalendar} />
				</div>
			}
			parentPath={paths.TRANSACTIONAL}
			content={<CrossSellingGlobalFilters />}
		/>
	)
}

export default CrossSellingSubHeader
